<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar flat color="white">
      <v-toolbar-title>Balance Withdraw Request Disbursed</v-toolbar-title>
      <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
        @keyup.enter="paginationMethod"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm12 md8 offset-sm2>
              <v-container fluid>
                <v-card>
                  <v-card-text>
                    <v-card-title class="indigo white--text">
                      <div class="headline">Withdraw request detail</div>
                    </v-card-title>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular"
                          ><b>Amount:</b></v-subheader
                        >
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{
                          editedItem.amount
                        }}</v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular"
                          ><b>Account holder name:</b></v-subheader
                        >
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{
                          editedItem.account_holder_name
                        }}</v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular"
                          ><b>Withdraw method name:</b></v-subheader
                        >
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{
                          editedItem.withdraw_method_name
                        }}</v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular"
                          ><b>Account number:</b></v-subheader
                        >
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{
                          editedItem.account_number
                        }}</v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular"
                          ><b>Transaction Id:</b></v-subheader
                        >
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{
                          editedItem.transaction_id
                        }}</v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular"
                          ><b>Disbursed At:</b></v-subheader
                        >
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{
                          editedItem.disbursed_at
                        }}</v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-if="editedItem.withdraw_method_id == 1">
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular"
                          ><b>Bank name:</b></v-subheader
                        >
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{
                          editedItem.bank_name
                        }}</v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-if="editedItem.withdraw_method_id == 1">
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular"
                          ><b>Branch name:</b></v-subheader
                        >
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{
                          editedItem.branch_name
                        }}</v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-if="editedItem.withdraw_method_id == 1">
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular"
                          ><b>Routing number:</b></v-subheader
                        >
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{
                          editedItem.routing_number
                        }}</v-subheader>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-flex>
          </v-layout>
          <!-- <v-divider inset></v-divider> -->
          <v-container fluid>
            <v-layout row>
              <div>
                <v-btn color="red" @click="close">Cancel</v-btn>
              </div>
            </v-layout>
          </v-container>
        </template>
      </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
    <div v-if="isLoaded">
      <div v-if="alertMsg">
        <v-alert
          v-if="error == 0 && statusCode == 200"
          :value="true"
          type="success"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 204"
          :value="true"
          type="info"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
          :value="true"
          type="warning"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 500"
          :value="true"
          type="error"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
      </div>
      <div v-if="indexData.balanceWithDrawStatus4.total < 1" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.balanceWithDrawStatus4.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.balanceWithDrawStatus4.total > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td class="text-xs-center">{{ props.item.amount }}</td>
          <td class="text-xs-center">{{ props.item.account_number }}</td>
          <td class="text-xs-center">{{ props.item.account_holder_name }}</td>
          <td class="text-xs-center">{{ props.item.withdraw_status_name }}</td>
          <td class="text-xs-center">{{ props.item.withdraw_method_name }}</td>
          <td class="text-xs-center">{{ props.item.transaction_id }}</td>
          <td class="text-xs-center">{{ props.item.disbursed_at }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.balanceWithDrawStatus4.from }} - {{ indexData.balanceWithDrawStatus4.to }} of
          {{ indexData.balanceWithDrawStatus4.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-layout wrap>
            <v-flex xs10 sm10 md10>
              <v-pagination
                right
                v-model="indexData.balanceWithDrawStatus4.current_page"
                :length="indexData.balanceWithDrawStatus4.last_page"
                @input="onPageChange"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </div>
      </template>
      <div>
        <v-btn
          v-if="indexData.balanceWithDrawStatus4.total"
          class="button"
          color="info"
          flat
          @click="download"
        >
          Click here to download disbursed list as excel
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import axios from "axios";
  import api from "../../../api/connectingUrls";
  import { saveAs } from "file-saver";

  export default {
    data: () => ({
      dialog: false,
      alertMsg: false,
      menu: false,
      menu2: false,
      time: null,
      date: null,
      apiUrl: "balance-withdraw-status",
      sl: 1,
      headers: [
      { text: "ID", align: "left", value: "id" },
      { text: "Amount", align: "center", value: "amount", sortable: true },
      {
        text: "Account Number",
        align: "center",
        value: "account_number",
        sortable: true,
      },
      {
        text: "Account Holder Name",
        align: "center",
        value: "account_holder_name",
        sortable: true,
      },
      { text: "Status", align: "center", value: "Status", sortable: true },
      {
        text: "Withdraw Method",
        align: "center",
        value: "withdraw_method",
        sortable: true,
      },
      {
        text: "Transaction Id",
        align: "center",
        value: "transaction_id",
        sortable: true,
      },
      {
        text: "Disbursed At",
        align: "center",
        value: "disbursed_at",
        sortable: true,
      },
      { text: "Actions", align: "center", value: "actions" },
      ],
      loading: false,
      search: "",
      rowsPerPageItems: [10, 20, 50, 100, 200, 500],
      editedIndex: -1,
      editedItem: {},
      pagination: {
        rowsPerPage: 10,
      },
      defaultItem: {
        rowsPerPage:10,
      },
      transDocs: {
        transaction_id: "",
        transaction_date: "",
        transaction_time: "",
        trans_image: null,
      },
      valid: true,
      inputRules: [(v) => !!v || "This field is required"],
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      isLoaded() {
        if (this.indexData.balanceWithDrawStatus4) {
          return true;
        } else {
          return false;
        }
      },
    },

    watch: {
      pagination() {
        this.onPageChange();
      },
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.$store.dispatch("changeBalanceWithdrawStatus", [this.apiUrl, 4, "", 1, this.pagination.rowsPerPage,""]);
    },

    methods: {
      initialize() {
        this.paginationMethod();
      },

      async download() {
        const token = window.localStorage.getItem("datadash_token");
        var fileName =
          "Mobile-Recharge-Disbursed-report" + new Date().toLocaleString();
        if (token != null) {
          await axios
            .get(`${api.rootUrl}/${"mr-export"}/${4}`, {
              file_name: fileName,
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              responseType: "blob",
            })
            .then((response) => {
              saveAs(response.data, fileName);
            });
        }
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },
      checkItem(item) {
        this.editedIndex = this.indexData.balanceWithDrawStatus4.data.indexOf(item);
        this.editedItem = Object.assign([], item);
        this.dialog = true;
      },
      exportData() {
        // alert("test");
        this.$store.dispatch("exportData", ["mr-export", 4]);
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      onPageChange() {
        this.paginationMethod();
      },

      paginationMethod() {
        // console.log("sear"+this.search)
        this.loading = true;

        if (this.search) {
          this.pagination.rowsPerPage=1000;
          this.$store.dispatch("changeBalanceWithdrawStatus", [this.apiUrl, 4, this.search, this.indexData.balanceWithDrawStatus4.current_page, this.pagination.rowsPerPage,""]);
          this.loading = this.indexData.balanceWithDrawStatus4.data ? false : true;
        } else {
          if(this.pagination.rowsPerPage==1000){
              this.pagination.rowsPerPage=10;
          }
          this.$store.dispatch("changeBalanceWithdrawStatus", [ this.apiUrl, 4, "", this.indexData.balanceWithDrawStatus4.current_page, this.pagination.rowsPerPage,""]);
          this.loading = !this.indexData.balanceWithDrawStatus4.error ? false : true;
        }
        this.dialog = false;
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>
